
import angular from 'angular';
import { AncillariesService } from '../../ib-web-ancillaries/ib-web-ancillaries-service';
import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/dist/ib-datalayer/ib-datalayer-constants';

const controllerInfo = {
    module: 'ib-globick-activities-module',
    inject: ['$scope', '$uibModalInstance', '$rootScope', '$window', '$timeout', '$document', '$compile', '$sce', 'localStorageService', 'CommonsGenericProxy', 'CommonsNewHttpUtilsErrorService', '$q', 'AncillariesConstants', 'ibGlobickActivitiesService', 'CommonsUtilService', 'AncillariesService', 'CommonsSessionStorageService', 'DatalayerUtils', 'DatalayerConstants'],
    required: []
};
export class ibGlobickActivitiesModalCtrl implements ng.IController {

    private tokenWidget;
    private flowApp = this.localStorageService.get('flowApp');
    private arrivalCity:any = '';
    private language:string = this.$rootScope.appLang;
    private arrivalCityDescription:any='';
    public phoneNumber = '';
    public prefix = '';
    public phonesList: any;
    public currentYear: any;

    private description:any = this.CommonsSessionStorageService.get('activitiesData') ? this.CommonsSessionStorageService.get('activitiesData')[1] : [];
    private price:any  = this.CommonsSessionStorageService.get('activitiesData') ? this.CommonsSessionStorageService.get('activitiesData')[2] : [];
    private date:string;
    private bookingReference:any  = this.CommonsSessionStorageService.get('activitiesData') ? this.CommonsSessionStorageService.get('activitiesData')[3] : [];

    private dateGoingTrip;
    private dateFormatGoingTrip;
    private dateFormattedGoingTrip:any  = this.CommonsSessionStorageService.get('activitiesData') ? this.CommonsSessionStorageService.get('activitiesData')[4] : [];
    private dateFormattedServiceGoingTrip:any = this.CommonsSessionStorageService.get('activitiesData') ? this.CommonsSessionStorageService.get('activitiesData')[0] : [];

    private hash: any;
    private isActivityRequested: boolean = false;

    constructor (
        private $scope: angular.IScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $rootScope: CommonsRootScope,
        private $window: angular.IWindowService,
        private $timeout: angular.ITimeoutService,
        private $document: ng.IDocumentService,
        private $compile: angular.ICompileService,
        private $sce: any,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private $q: ng.IQService,
        private AncillariesConstants: AncillariesConstant,
        private ibGlobickActivitiesService: any,
        private CommonsUtilService,
        private AncillariesService: AncillariesService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerConstants: DatalayerConstantsType) {
        this.$scope.$on('closeTransferModal', this.close);
        this.$scope.$on('completeActivityFlow', this.completeActivityFlow);
        this.$scope.$on('updateArrayActivities', this.updateArrayActivities);
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        this.loadWidgetsScripts();
        this.phonesList = this.localStorageService.get('phonesList');
        this.currentYear = new Date().getFullYear();
        if (this.phonesList && this.phonesList.RESERVAS) {
            this.phoneNumber = this.phonesList.RESERVAS.telephone;
            this.prefix = this.phonesList.RESERVAS.prefix;
        }
        this.$timeout(() => {
            this.initActivityWidget();
        }, 1500);

        this.$timeout(() => {
            angular.element('#overlay-activities').addClass('u-hide');
        }, 4000);
    }

    getEnvUrlToGetWidgetCode (): string {
        const env = '';
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        return envCopy.urlEnvironment;

    }

    loadWidgetsScripts (): void {

        const widgetVersion = '2.2.9';
        const baseUrl = this.getEnvUrlToGetWidgetCode();
        const urlActivities = baseUrl + 'iberia-web-content/build-recoglobick-activities/' + widgetVersion;

        const scriptActivityVendor = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/2.vendor.chunk.js') + '"</script>';
        const scriptActivityMain = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/main.chunk.js') + '"</script>';
        const scriptActivityRunTime = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/runtime-main.js') + '"</script>';
        const cssActivitiesVendor = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/css/2.vendor.chunk.css') + '">';
        const cssActivitiesMain = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/css/main.chunk.css') + '">';
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivityVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivityMain)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivityRunTime)(this.$scope));

        angular.element(this.$document).find('body').prepend(this.$compile(cssActivitiesVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(cssActivitiesMain)(this.$scope));
    }

    getSegmentOW = (context:any):any => {
        const segments = context?.segments;
        const slices = context?.slices[0];
        let sliceActived;
        for (let i=0; i<segments?.length; i++) {
            for (let j=0; j<slices?.segmentIds.length; j++) {
                if (segments[i]?.id === slices.segmentIds[j]) {
                    sliceActived = segments[i];
                }
            }
        }
        return sliceActived;
    };

    updateArrayActivities = (index) => {
        this.description.splice(index, 1);
        this.price.splice(index, 1);
        this.bookingReference.splice(index, 1);
        this.dateFormattedGoingTrip.splice(index, 1);
        this.dateFormattedServiceGoingTrip.splice(index, 1);
    };

    postOrderCallback = (evt) => {

        this.description.push(evt.name);
        this.price.push(evt.price);
        this.date = evt.startDate;
        this.bookingReference.push(evt.bookingReference);

        this.dateGoingTrip = this.date;
        this.dateFormatGoingTrip = new Date(this.dateGoingTrip);
        this.dateFormattedGoingTrip.push(String(this.dateFormatGoingTrip.getDate()).padStart(2, '0') + '/' + String(this.dateFormatGoingTrip.getMonth()+1).padStart(2, '0') + '/' + this.dateFormatGoingTrip.getFullYear());
        this.dateFormattedServiceGoingTrip.push(this.dateFormatGoingTrip.getFullYear() + '-' + String(this.dateFormatGoingTrip.getMonth()+1).padStart(2, '0') + '-' + String(this.dateFormatGoingTrip.getDate()).padStart(2, '0') + 'T' + String(this.dateFormatGoingTrip.getHours()).padStart(2, '0') + ':' + String(this.dateFormatGoingTrip.getMinutes()).padStart(2, '0'));

        this.hash = this.localStorageService.get('clientBookingIdActivities');

        this.localStorageService.set('bookingReferencesActivities', this.bookingReference);

        const bookingReferences:any =  this.localStorageService.get('bookingReferencesActivities');

        const deleteInfo = [
            {
                type: this.AncillariesConstants.TYPE_ANCILLARIE.GLOBICK,
                items: [
                    {
                        product: 'EXP',
                        bookingReferences: [bookingReferences]
                    }
                ]
            }
        ];

        this.CommonsSessionStorageService.set('removeGlobickActivities', deleteInfo);
        this.isActivityRequested = true;

        //Add datalayer select_item
        this.DatalayerUtils.setActivitiesEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.SELECT_ITEM, this.price, this.description);
    };

    getRecommendationCallback = () => {};

    generateTravellers = () => {
        const bookingInfo:any = this.localStorageService.get('bookingInfo');
        const listTravellers = [];
        let travellerTemp = {};


        Object.keys(bookingInfo.passengers).forEach(key => {
            travellerTemp = {};

            travellerTemp = {
                name: bookingInfo.passengers[key].name,
                surname:  bookingInfo.passengers[key].surname,
                email:  '',
                dob:  '',
                address: '',
                country: '',
                countryPhoneCode: '',
                phone: '',
                countryMobileCode: '',
                mobile: '',
                language: '',
                nationality: '',
                passport: '',
                expenditureDate: '',
                expirationDate: '',
                zipCode: '',
                pickupLocation: ''
            };
            listTravellers.push(travellerTemp);
        });
        return listTravellers;
    };

    checkWithChildren = () => {
        const withChildren = false;
        return withChildren;
    };

    checkBusinessTrip = () => {
        const UserLogged = this.localStorageService.get('userLogged');
        let isBusinessTrip = false;

        if(UserLogged === 'ONB') {
            isBusinessTrip = true;
        }

        return isBusinessTrip;
    };

    expiredTokenCallback = () => {
        this.initActivityWidget();
    };

    generateMountLocation (): string {
        const flowName = this.$rootScope.flowName;
        let flowNameReturned;
        if(flowName === 'BKI' || flowName === 'CKI' || flowName === 'MMB') {
            flowNameReturned = flowName;
        }else {
            flowNameReturned = '';
        }
        return flowNameReturned;
    }

    generateLanguageAndMarket (): string {
        const confirmationDatalayerInfo:any = (this.flowApp === 'BKI' || this.flowApp === 'BBKI') ? this.localStorageService.get('fareData') : this.localStorageService.get('confirmationDigitalInfo');
        let languageAndMarket;

        if (this.flowApp === 'BKI' || this.flowApp === 'BBKI') {
            if(confirmationDatalayerInfo.contextMetadata.language === 'es' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'ES';
            }else if(confirmationDatalayerInfo.contextMetadata.language === 'en' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'US';
            }else if(confirmationDatalayerInfo.contextMetadata.language === 'zh' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'CN';
            }
        } else {
            if(confirmationDatalayerInfo.Language === 'es' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'ES';
            }else if(confirmationDatalayerInfo.Language === 'en' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'US';
            }else if(confirmationDatalayerInfo.Language === 'zh' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'CN';
            }
        }
        return languageAndMarket;
    }

    checkIsPro (): string {
        let isPro;
        const widgetProMonetate = this.localStorageService.get('widgetProMonetate');
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        if(envCopy.production || widgetProMonetate) {
            isPro = 'prod';
        }else {
            isPro = 'test';
        }
        return isPro;
    }

    generateActivityReactWidgetModel = () => {
        let widgetModel: any = {};
        const flightAviosInfo:any = this.localStorageService.get('flightAviosInfo');
        const commercialData:any = this.localStorageService.get('commercialData');
        const bookingID:any = this.localStorageService.get('createOrderData');
        const bookingDate:any = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? this.localStorageService.get('breakdownInfo') : this.localStorageService.get('summaryInfo');
        const date:any = new Date().toTimeString().split(' ')[0];
        const hash:any = (this.flowApp === 'BKI' || this.flowApp === 'BBKI') ?  bookingID.order.bookingReferences[0].reference + '-' + bookingDate.context.bookingDate.split(' ')[0].replaceAll('-', '') : bookingDate.context.locator + '-' + bookingDate.context.bookingDate.split(' ')[0].replaceAll('-', '');
        const arrivalDateForGlobick = this.getSegmentOW(bookingDate.context);
        const locationForGlobick = arrivalDateForGlobick.arrivalAirport;
        const currencyModel:any = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? commercialData?.currency.code : flightAviosInfo.currency.code;
        const originDestination:any = this.localStorageService.get('segmentsInfo');
        const descriptionOW = originDestination.find((item) => item.destination.code === locationForGlobick);

        const generate = () => {
            return this.CommonsUtilService.sha256(hash).then((hashEID) => {
                widgetModel = {
                    env: this.checkIsPro(),
                    token: 'Bearer' + ' ' + this.tokenWidget,
                    clientBookingId: hashEID,
                    startDate: arrivalDateForGlobick.arrivalDate.split(' ')[0],
                    endDate: null,
                    location: this.ibGlobickActivitiesService.locationForWidget(locationForGlobick),
                    totalTickets: bookingDate.context.passengers.length,
                    businessTrip:  this.checkBusinessTrip(),
                    withChildren: this.checkWithChildren(),
                    ages: null,
                    language: this.generateLanguageAndMarket(),
                    currency: currencyModel,
                    currencyExchange: null,
                    gaTrackingCode: 'test',
                    travellers: this.generateTravellers(),
                    mountLocation: this.generateMountLocation(),
                    postOrderCallback: this.postOrderCallback,
                    getRecommendationCallback: this.getRecommendationCallback,
                    expiredTokenCallback: this.expiredTokenCallback
                };
                this.localStorageService.set('clientBookingIdActivities', hashEID);
                this.arrivalCity = locationForGlobick;
                this.arrivalCityDescription = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? descriptionOW.destination.description : '';
                return widgetModel;
            });
        };

        return generate().then((widgetModel) => {
            return widgetModel;
        });
    };

    reInitActivityWidget  = () => {
        this.$uibModalInstance.close();
        this.$timeout(() => {
            this.$rootScope.$broadcast('openActivitiesModal');
        }, 1500);
    };


    initActivityWidget = () => {
        this.ibGlobickActivitiesService.getTokenWidget().then((response) => {
            this.tokenWidget = response.data.access_token;
            this.generateActivityReactWidgetModel().then((reactWidgetModel) => {
                this.$window.RecoglobickActivitiesWidget.mount(reactWidgetModel);
            });
        });
    };

    completeActivityFlow = (): void => {
        this.$rootScope.$broadcast('setConfirmed');
    };

    /**
    * Close modal and send event for discard changes on insurance
    */
    close = (): void => {
        if (this.isActivityRequested) {
            this.AncillariesService.updateGlobickActivities(this.dateFormattedServiceGoingTrip, this.description, this.price, this.hash, this.bookingReference).then(() => {
                this.AncillariesService.addGlobickActivitiesToBasket(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), this.dateFormattedGoingTrip, this.description, this.price);
                this.completeActivityFlow();
                //Add datalayer add_to_cart
                this.DatalayerUtils.setActivitiesEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART, this.price, this.description);
            }, angular.noop);
            this.isActivityRequested = false;
            this.CommonsSessionStorageService.set('activitiesData', [this.dateFormattedServiceGoingTrip, this.description, this.price, this.bookingReference, this.dateFormattedGoingTrip]);
        }
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        angular.element('#overlay-activities').removeClass('u-hide');
    };
}


try {
    ibGlobickActivitiesModalCtrl.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ibGlobickActivitiesModalCtrl.name, ibGlobickActivitiesModalCtrl);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ibGlobickActivitiesModalCtrl.$inject = controllerInfo.inject;
    mod.controller(ibGlobickActivitiesModalCtrl.name, ibGlobickActivitiesModalCtrl);
}